/**
 * Shared render helpers for the Help pages (table of contents, section
 * pages, changelog). Kept in one place so the manual and the changelog
 * format identically across the routed pages.
 */

/**
 * Display-only: mark the first standalone EVII as EVII (trademark). The
 * @evi/content source stays plain "EVII" because it also feeds EVII's
 * prompt, where plain reads naturally; the trademark is added here, at
 * render. Word-boundary so it never touches "EVI", and non-global so only
 * the first mention per string is marked.
 */
export function markEvie(text: string): string {
  return text.replace(/\bEVIE\b/, 'EVII™');
}

/**
 * Format an ISO date (YYYY-MM-DD) without a timezone shift. Parsing the
 * parts directly avoids `new Date(iso)`, which reads the string as UTC
 * midnight and can roll back a day in negative-UTC zones.
 */
export function formatDate(iso: string): string {
  const [y, m, d] = iso.split('-').map(Number);
  if (!y || !m || !d) return iso;
  return new Date(y, m - 1, d).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}
